import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
    name: 'space'
})
export class SpacePipe implements PipeTransform {
    transform(value: any, args?: any): any {
        return addSpaceToDigit(value);
    }
}
export function addSpaceToDigit(value) {
    if (value !== null) {
        return value.replace('Rs.', 'Rs.   ');
    }
}
